import React from 'react';
import hero from '../assets/img/logo.png';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useHistory} from "react-router-dom";
import {DrawerData} from "./drawer-data";
import {AuthContext, DataContext} from "../Context";

const Drawer = () => {
    const [dataContext, dataState] = React.useContext(DataContext);
    const [authContext, loginState] = React.useContext(AuthContext);
    const history = useHistory();
    const [data, setData] = React.useState({
        selectedMenu: 'dashboard',
    })

    const selectMenu = (menu) => {
        setData({
            ...data,
            selectedMenu: menu
        })
        history.push(menu)
    }

    const onLogout = () => {
        authContext.signOut();
        dataContext.clearData();
        history.push('/');
    }

    const selectedClassName = (selected) => {
        return window.location.pathname === '/admin/' + selected ? "drawer-pile" : "drawer-pile-unselected";
    }

    return (
        <div className="drawer">
            <div className="drawer-container">
                <div className="drawer-menu">
                    <div>
                        <img className="drawer-logo" src={hero} alt="hero"/>
                    </div>

                    {DrawerData.map((item, index) => {
                        return (
                            <div key={index} className={selectedClassName(item.cName)}
                                 onClick={() => selectMenu(item.cName)}>
                                <FontAwesomeIcon icon={item.icon}/>
                                <div className="h-spacer"/>
                                <div className="pile-title">{item.title}</div>
                            </div>
                        );
                    })}
                </div>
                <div className="drawer-bottom">
                    <div className="drawer-log-out" onClick={() => onLogout()}>
                        logout
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Drawer;
